export const COOKEY_KEY = {
  USER: 'user',
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  AUTHENTICATION: 'authentication',
  THEME_TYPE: 'theme',
};

export const COOKEY_OPTION = {
  DOMAIN: 'blockai.kr',
  EXPIRES_TIME: 1000 * 60 * 60 * 24 * 365, // 1년
};
